import React, { FC } from 'react';
import { PROVIDER_DETAILS_FORM_FIELDS } from '../../constants/provider/provider-details-form';
import { VALUE_TYPE } from '../general-components/NumberFormatterComponent';
import { AdvancedInput } from '../general-components/AdvancedInput';
import { Title } from '../developers/page-components/Title';
import clsx from 'clsx';
import { ProgressBar } from '../general-components/ProgressBar';
import { numberFormatter } from '../../utils/utilities';
import { faInfinity } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IFormattedProviderProps } from '../../store/tables/admin/provider-data';

interface Props {
  formik: any;
  fieldName: PROVIDER_DETAILS_FORM_FIELDS,
  inputType: 'string' | 'number';
  label: string;
  tooltipText: string;
  placeholder?: string;
  additionalLabelClasses?: string;
  additionalInputClasses?: string;
  loading?: boolean;
  onConfirm: (fieldName: string) => Promise<void>;
  isEditable?: boolean;
  isUnlimited?: boolean;
  metricValue?: number;
  metricType?: VALUE_TYPE;
  metricCurrency?: string;
  formattedValue?: () => string;
  formattedTooltipValue?: () => string;
  showValueInTooltip?: boolean;
  orientation?: 'horizontal' | 'vertical';
  providerDetailsData: IFormattedProviderProps;
}

export const MetricInputComponent: FC<Props> = (props) => {
  const {
    formik,
    fieldName,
    inputType,
    label,
    tooltipText,
    placeholder,
    additionalLabelClasses,
    additionalInputClasses,
    loading,
    onConfirm,
    isUnlimited,
    isEditable = false,
    metricValue,
    metricType,
    metricCurrency,
    formattedValue,
    formattedTooltipValue,
    showValueInTooltip,
    orientation = 'vertical',
    providerDetailsData,
  } = props;

  const value = formik.values[fieldName];

  const percent = value && metricValue ? (metricValue / value) * 100 : 0;

  const getTitle = (): string | JSX.Element => {
    if (value === null || value === '') {
      return <FontAwesomeIcon icon={faInfinity} width={12}/>;
    } else {
      return percent === 0 || Number.isInteger(percent) ? percent + '%' : numberFormatter(percent) + '%' ;
    }
  };

  return (
    <div className="d-flex">
      <AdvancedInput
        formik={formik}
        fieldName={fieldName}
        inputType={inputType}
        label={label}
        tooltipText={tooltipText}
        placeholder={placeholder}
        additionalLabelClasses={additionalLabelClasses}
        additionalInputClasses={additionalInputClasses}
        additionalContainerClasses="col-6"
        loading={loading}
        onConfirm={onConfirm}
        isEditable={isEditable}
        isUnlimited={isUnlimited}
        metricValue={metricValue}
        metricType={metricType}
        metricCurrency={metricCurrency}
        formattedValue={formattedValue}
        formattedTooltipValue={formattedTooltipValue}
        showValueInTooltip={showValueInTooltip}
        orientation={orientation}
        providerDetailsData={providerDetailsData}
      />

      <div className="d-flex align-items-center mb-5">
        <ProgressBar percent={percent} additionalClass="w-100px" />
        <Title title={getTitle()} additionalClass={clsx('fs-7 ms-2', percent >= 75 && 'text-danger')} />
      </div>
    </div>
  );
};